
import $ from "jquery"
import _once from "lodash/once"
import L from "plugins/leaflet"
import Promise from "plugins/bluebird"

import AssetsInfoStore from "app/assets_info_store"

import DomIdGenerator from "app/utils/dom_id_generator"

import LeafletMapTileLayer from "app/map/leaflet/map_tile_layer"


interface InputSelector {
  main?:           string | JQuery | HTMLElement,
  map_container?:  string,
}

interface Selector {
  main:           string | JQuery,
  map_container:  string,
}

const default_selector: Selector = {
  main:           ".cell-new-development-building-carousel-map-view",
  map_container:  ".cell-new-development-building-carousel-map-view__static-map-box",
}


const init = (selector?: InputSelector) => {
  const sele: Selector = Object.assign({}, default_selector, selector)

  const $el = $(sele.main)
  const $map_container = $el.find(sele.map_container)

  const render_map = _once(() => {
    const map_el = $map_container[0]

    const dom_id = DomIdGenerator.generateNewId()
    // Set new ID if applicable
    if (dom_id !== map_el.id) { map_el.setAttribute("id", dom_id) }

    const lat = parseFloat($map_container.data("lat"))
    const lng = parseFloat($map_container.data("lng"))
    const center = L.latLng(lat, lng)

    // Generate ID for Leaflet map, if absent
    const map_canvas_dom_id = dom_id

    // If we add map tile layer AFTER creating map object
    // The location of tile layer is drifted on load
    // To workaround this we create tile layer first and
    // pass it on map object creation
    Promise.all([
      LeafletMapTileLayer.getNewTileLayerPromise(),
      AssetsInfoStore.fetch("map/markers/s-spacious.png"),
    ])
    .spread((map_tile_layer, icon_image_data) => {
      const leaflet_map =
        L.map(map_canvas_dom_id, {
          center: center,

          zoom:    17,
          minZoom: 17,
          maxZoom: 17,

          // Interaction Options
          dragging:        false,
          touchZoom:       false,
          scrollWheelZoom: false,
          doubleClickZoom: false,
          boxZoom:         false,
          tap:             false,

          // Control options
          zoomControl:        false,
          attributionControl: false,

          layers: [
            map_tile_layer,
          ],
        })

      const marker_icon = L.icon({
        iconUrl:  icon_image_data.url,
        iconSize: [25, 29],
      })
      L.marker(center, {
        icon: marker_icon,
      }).addTo(leaflet_map)
    })
    .done()
  })


  render_map()
}


export default {
  init: init,
}
